import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Textarea,
  Text,
  VStack,
  Checkbox,
} from "@chakra-ui/react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

interface RejectReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isLoading?: boolean;
}

const validationSchema = Yup.object().shape({
  reason: Yup.string()
    .required("Motivo é obrigatório")
    .min(10, "Motivo deve ter pelo menos 10 caracteres"),
});

export default function RejectReasonModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: RejectReasonModalProps) {
  const [sendCopy, setSendCopy] = useState(false);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="lg">
        <ModalHeader fontSize="xl" fontWeight="bold" color="gray.900">
          Motivo da recusa
        </ModalHeader>
        <ModalCloseButton />
        <Formik
          initialValues={{ reason: "" }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            onConfirm(values.reason);
          }}
        >
          {({ errors }) => (
            <Form>
              <ModalBody>
                <VStack spacing={4} align="stretch">
                  <Text fontSize="sm" color="gray.600">
                    Informe o motivo da recusa. Este motivo será enviado ao
                    cliente por e-mail.
                  </Text>

                  <VStack align="start" spacing={1}>
                    <Text fontSize="sm" fontWeight="medium" color="gray.700">
                      Motivo da recusa *
                    </Text>
                    <Field name="reason">
                      {({ field }: any) => (
                        <Textarea
                          {...field}
                          placeholder="Digite o motivo da recusa..."
                          minH="100px"
                          resize="vertical"
                          isInvalid={!!errors.reason}
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="reason"
                      render={(msg) => (
                        <Text fontSize="xs" color="red.500">
                          {msg}
                        </Text>
                      )}
                    />
                  </VStack>

                  <Checkbox
                    isChecked={sendCopy}
                    onChange={(e) => setSendCopy(e.target.checked)}
                    colorScheme="blue"
                  >
                    <Text fontSize="sm">Enviar cópia para meu e-mail</Text>
                  </Checkbox>
                </VStack>
              </ModalBody>

              <ModalFooter justifyContent="flex-end" gap={3}>
                <Button variant="ghost" onClick={onClose} disabled={isLoading}>
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  colorScheme="red"
                  isLoading={isLoading}
                  loadingText="Confirmando..."
                >
                  Confirmar recusa
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );
}
